/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsRailcarSideView: {
  name: 'railcar-side-view';
  data: string;
} = {
  name: 'railcar-side-view',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 1.5A1.5 1.5 0 0 0 1.5 3v5a1.5 1.5 0 0 0 1 1.415V10.5H1a.5.5 0 0 0 0 1h.768a2 2 0 1 0 3.465 0h5.535a2 2 0 1 0 3.465 0H15a.5.5 0 0 0 0-1h-1.5V9.415A1.5 1.5 0 0 0 14.5 8V3A1.5 1.5 0 0 0 13 1.5H3Zm.5 9h9v-1h-9v1Zm-.5-2h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5Zm-.5 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm10-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" fill="currentColor"/></svg>`,
};
